import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClientTable from '../../AppGrid/ClientTable';
import strings from '../../Globalization/index';
import HelpForm from '../forms/HelpForm';

class ClientList extends Component {
	constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            filename: '',
        };
    }
	openHelp(filename) {
        this.setState({
            openModal: true,
            filename: filename
        });
    }

    // Function to handle closing the modal
    closeHelp() {
        this.setState({
            openModal: false,
            filename: ''
        });
    }
    render() {
		const { openModal, filename } = this.state;
        return (
            <div id="wrapper ibox float-e-margins">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-1 col-md-1 col-sm-1 default-color pull-right help-icon-align">
                        <span onClick={this.openHelp(this, strings.Client)} className="header-icon" title={strings.Help}>
                            <i className="fa fa-question-circle fa-2x img-responsive center-block" />
                        </span>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-10 default-color">
                        <h2>{strings.Client}</h2>
                        <ol className="breadcrumb">
                            <li>
                                <span>{strings.Admin}</span>
                            </li>
                            <li className="active">
                                <span>{strings.Client}</span>
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row wrapper ibox-content float-e-margins">
                        <ClientTable scope={this} title={strings.Client} />
                    </div>
                </div>
				<HelpForm filename={filename} isOpen={this.state.openModal} closeModal={() => this.closeHelp()} />
            </div>
        );
    }
}

ClientList.propType = {
	router: PropTypes.object.isRequired
};
 
export default ClientList